<?php
\Core\View::$template = function () {
    $html = '
    <div class="nav_wrap">
      <nav class="navbar navbar-expand-lg fixed-top nav-transparent">
      <div class="container">
        <a class="navbar-brand" href="#" style="height: 90px;">
          <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/logg.png" height="80">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"><i class="fa fa-bars"></i></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item active">
              <a class="nav-link" href="#">
                Invite
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link go-register-hiring" href="/register/hiring">Looking for Staff?</a>
            </li>
            <li class="nav-item">
              <a class="nav-link go-register-employee" href="/register/employee">Looking for Work?</a>
            </li>
            <!--<li class="nav-item">
              <a class="nav-link go-register-hiring" href="/register/hiring">Hiring?</a>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-signup go-jobslist" href="/jobslist">Jobs</a>
            </li>-->
            <li class="nav-item">
              <a class="nav-link nav-signup go-login-page" href="/login" >Login</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </div>

    <section class="general top-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-5 col-xs-12 col-12 top-info">
            <h1>Tech Friendly Recruitment<br> for a Digital Age</h1>
            <p class="sub-head">No more </p>
            <p class="sub-head-small">
              Video Interviews is currently open to Candidates in the following fields:
            </p>
            <ul>
                <li>Techies: developers, designers, data scientists & product/project managers</li>
                <li>Office: Customer Service, Administrators</li>
                <li>Professional Services: Legal, Accountancy, Banking</li>
            </ul>
            <button class="btn btn-join go-register-employee">Join as talent</button>
            <p>Are you hiring? <a href="/register/hiring" class="go-register-hiring" id="go-register-hiring">Sign up as an Employer</a> </p>
          </div>
        </div>
      </div>
    </section>
    
    <section class="general">
      <div class="container">
        <div class="row clearfix">
          <div class="col-md-4 col-xs-12 col-lg-5">
            <h2>Interview Once for Multiple Roles | Multiple Interviews for one Role</h2>
            <p>
              Candidates can interview once for multiple roles. Your Interviewers could interview you once or multiple
              times, for multiple roles - from the comfort of your Laptop.
            </p>
          </div>
          <div class="col-md-6 col-xs-12 col-lg-6 offset-md-1 offset-lg-1 text-center">
            <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/transfer2.png" class="img-fluid">
          </div>
        </div>
      </div>
    </section>';


    $html = $html . '

    <section class="section-control  text-center">
      <div class="container">
        <h2 class="text-center">Putting developers in control </h2>
        <div class="row clearfix">
          <div class="col-md-4 col-lg-4 col-xs-12">
            <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/user-control.png">
            <h5>You are in control</h5>
            <p>
              On Video Interviews Developers do not apply to companies, companies apply to developers. There are no recruiters. And your personal contact details are never shown.
            </p>
          </div>
          <div class="col-md-4 col-lg-4 col-xs-12">
            <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/target.png">
            <h5>Not actively looking right now?</h5>
            <p>
              On Video Interviews , you can see what other opportunities are out there without leaving the safety of your current position and your Talent Manager will introduce you to your favourite companies.
            </p>
          </div>
          <div class="col-md-4 col-lg-4 col-xs-12">
            <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/incognito.png">
            <h5>Stay anonymous</h5>
            <p>
              Your current employer will never see your Video Interviews profile. And if there are any other companies you want to stay hidden from then just let us know.
            </p>
          </div>
        </div>
        <button class="btn btn-join-small go-register-employee">Join as talent</button>
      </div>
    </section>';


    $html = $html . '

    <section class="general">
      <div class="container">
        <div class="col-md-8 col-lg-8 col-xs-12 justify-content-md-center justify-content-lg-center center-block">
        <h2 class="work-head">How it works</h2>
        <div class="row clearfix hw-container">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="row clearfix">
              <div class="col-md-6 col-lg-6 col-xs-12 order-1 text-center work_style_wrap">
                <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/create_pro.png">
              </div>
              <div class="col-md-6 col-lg-6  order-2 col-xs-12 work_style_wrap">
                <h5 class="h-sub-m">Create your profile</h5>
                <p>
                  First thing first, create your profile. Let companies know why yo are the person for the job.
                </p>
              </div>
            </div>
          </div>
          <div class="divider-ax1"></div>
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="row clearfix">
              <div class="col-md-6 col-lg-6 col-xs-12  order-2 text-right work_style_wrap">
                <h5 class="h-sub-m">Wait for your job offers</h5>
                <p>
                  Companies will apply to you with a salary and job spec up front.
                </p>
              </div>
              <div class="col-md-6 col-lg-6 col-xs-12  order-1 text-center work_style_wrap">
                <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/mail.png">
              </div>
            </div>
          </div>
          <div class="divider-ax2"></div>
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="row clearfix">
              <div class="col-md-6 col-lg-6 col-xs-12  order-1 text-center work_style_wrap">
                <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/pick_offer.png">
              </div>
              <div class="col-md-6 col-lg-6 col-xs-12  order-2 work_style_wrap">
                <h5 class="h-sub-m">Pick offers and reach out</h5>
                <p>
                  Choose the offers that interest you and speak to companies directly. There is no recruiters getting in the way.
                </p>
              </div>
            </div>
          </div>
          <div class="divider-ax1"></div>
          <div class="col-md-12 col-lg-12 col-xs-12 text-right ">
            <div class="row clearfix">
              <div class="col-md-6 col-lg-6 col-xs-12  order-2 work_style_wrap">
                <h5 class="h-sub-m">Accept your dream job</h5>
                <p>
                  It is all sun shines and rainbows from this point on. Enjoy your new job!
                </p>
              </div>
              <div class="col-md-6 col-lg-6 col-xs-12  text-center  order-1 work_style_wrap">
                <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/accept_job.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
    <hr>';


    $html = $html . '

    <section class="general">
      <div class="container common_question_wrap">
        <h2 >Common Questions</h2>
        <div class="row clearfix">
          <div class="col-md-5 col-lg-5 col-xs-12">
            <p>
              If you are still unsure of the benefits to Video Interviews (there are many) here are some common questions we receive.
            </p>
          </div>
          <div class="col-md-5 col-lg-5 offset-lg-2 offset-md-2">
            <div class="accordion accordion-cstm" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h5 class="mb-0">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                      What sorts of roles do you have?
                    </button>
                  </h5>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">
                    Currently we work with companies seeking Software Developers, Designers, Data Scientists and Product Managers. However watch this space as we are growing fast.
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style="    white-space: normal;
    word-wrap: break-word;">
                      Can my current employer see my profile?
                    </button>
                  </h5>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                  <div class="card-body">
                    You can always choose to be hidden from your present employers. Further, you can hide your profile from specific other companies too.
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingThree">
                  <h5 class="mb-0">
                    <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      How long does the application take?
                    </button>
                  </h5>
                </div>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                  <div class="card-body">
                    It should take 2 mins to fill in our simple on boarding form. We&apos;ll let you know when we&apos;re
                    opening up your account for full access!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>';


//    $html = $html . '
//
//    <section class="testimonial">
//      <h2 class="text-center">What our users have to say</h2>
//      <div id="demo" class="carousel slide">
//        <ol class="carousel-indicators">
//          <li data-target="#demo" data-slide-to="0" class="active"></li>
//          <li data-target="#demo" data-slide-to="1"></li>
//          <li data-target="#demo" data-slide-to="2"></li>
//        </ol>
//        <div class="carousel-inner">
//          <div class="carousel-item active">
//            <div class="slide-item text-center">
//              <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/sam.jpg" width="50px" class="rounded-circle">
//              <p>
//                Video Interviews made it really easy to talk directly to the people who were hiring, which made the whole process much more transparent and comfortable than playing Chinese Whispers with a recruiter. I would definitely use them again!
//              </p>
//              <h4>Akbar</h4>
//            </div>
//          </div>
//
//          <div class="carousel-item">
//            <div class="slide-item text-center">
//              <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/giovanni.jpg" width="50px" class="rounded-circle">
//              <p>
//                Video Interviews made it really easy to talk directly to the people who were hiring, which made the whole process much more transparent and comfortable than playing Chinese Whispers with a recruiter. I would definitely use them again!
//              </p>
//              <h4>Akbar</h4>
//            </div>
//          </div>
//
//          <div class="carousel-item">
//            <div class="slide-item text-center">
//              <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/ed.jpg" width="50px" class="rounded-circle">
//              <p>
//                Video Interviews made it really easy to talk directly to the people who were hiring, which made the whole process much more transparent and comfortable than playing Chinese Whispers with a recruiter. I would definitely use them again!
//              </p>
//              <h4>Akbar</h4>
//            </div>
//          </div>
//        </div>
//
//        <a href="#demo" data-slide="prev" class="carousel-control-prev">
//          <span class="carousel-control-prev-icon"></span>
//        </a>
//        <a href="#demo" data-slide="next" class="carousel-control-next">
//          <span class="carousel-control-next-icon"></span>
//        </a>
//      </div>
//
//    </section>';


    $html = $html . '

    <section class="footer-bottom">
      <div class="container">
        <div class="row clearfix">
          <div class="col-md-3 col-12 col-xs-12 col-lg-3 copyright_footer">
            © 2023 Video Interviews
          </div>
          <div class="col-md-9 col-12 col-xs-12 col-lg-9">
            <ul class="footer-links">
              <li>
                <a class="go-about-us" href="/about-us">About</a>
              </li>
              <!--<li>
                <a class="go-jobslist" href="/jobslist">Jobs</a>
              </li>-->
              <li>
                <a class="go-careers-with-us" href="/careers-with-us">Careers</a>
              </li>
              <li>
                <a class="go-privacy-policy" href="/privacy">Privacy</a>
              </li>
              <li>
                <a class="go-terms-conditions" href="/terms-and-conditions">Terms</a>
              </li>
              <li>
                <a class="go-contact" href="/contact-us">Contact</a>
              </li>
              <li>
                <a class="go-affiliates" href="/affiliates">Affiliates</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>';

    return $html;
};




// WEBPACK FOOTER //
// app/LandingPage/View/LandingPage.php